import { useState } from 'react';
import './Footer.css';

function LinkedInIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
    </svg>
  );
}

function MailIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="2" y="4" width="20" height="16" rx="2"/>
      <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
    </svg>
  );
}

function LocationIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/>
      <circle cx="12" cy="10" r="3"/>
    </svg>
  );
}

export default function Footer() {
  const [status, setStatus] = useState('idle'); // idle | sending | success | error

  async function handleSubmit(e) {
    e.preventDefault();
    setStatus('sending');
    const data = new FormData(e.target);
    const res = await fetch('https://formspree.io/f/xrewnnwv', {
      method: 'POST',
      body: data,
      headers: { Accept: 'application/json' },
    });
    if (res.ok) {
      setStatus('success');
      e.target.reset();
    } else {
      setStatus('error');
    }
  }

  return (
    <footer className="footer" id="contact">
      <div className="footer-bg">
        <img src="/images/nursery_1.jpg" alt="Nursery" />
        <div className="footer-overlay" />
      </div>
      <div className="footer-inner">

        <div className="footer-contact-section">
          <div className="footer-contact-left">
            <p className="section-label" style={{ color: 'var(--terracotta-light)' }}>Contact</p>
            <h2 className="footer-heading">Let's connect.</h2>
            <div className="divider" style={{ background: 'var(--terracotta)' }} />
            <p className="footer-sub">
              Whether you're an investor, a rural entrepreneur, a prospective partner, or someone who simply believes in what we're building — we'd love to hear from you.
            </p>
            <div className="footer-details">
              <a href="mailto:info@aranyakam.co.in" className="footer-detail-row">
                <MailIcon />
                <span>info@aranyakam.co.in</span>
              </a>
              <a
                href="https://www.linkedin.com/company/aranyakam-ventures"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-detail-row"
              >
                <LinkedInIcon />
                <span>Aranyakam on LinkedIn</span>
              </a>
              <div className="footer-detail-row footer-detail-address">
                <LocationIcon />
                <span>Tamil Nadu, India</span>
              </div>
            </div>
          </div>

          <div className="footer-form-wrap">
            {status === 'success' ? (
              <div className="footer-form-success">
                <p className="footer-form-success-title">Message sent.</p>
                <p className="footer-form-success-body">Thanks for reaching out — we'll get back to you soon.</p>
              </div>
            ) : (
              <form className="footer-form" onSubmit={handleSubmit}>
                <div className="footer-form-row">
                  <div className="footer-field">
                    <label htmlFor="contact-name">Name</label>
                    <input id="contact-name" name="name" type="text" placeholder="Your name" required />
                  </div>
                  <div className="footer-field">
                    <label htmlFor="contact-email">Email</label>
                    <input id="contact-email" name="email" type="email" placeholder="your@email.com" required />
                  </div>
                </div>
                <div className="footer-field">
                  <label htmlFor="contact-subject">Subject</label>
                  <input id="contact-subject" name="subject" type="text" placeholder="How can we help?" />
                </div>
                <div className="footer-field">
                  <label htmlFor="contact-message">Message</label>
                  <textarea id="contact-message" name="body" rows="5" placeholder="Tell us about yourself and what you have in mind..." required />
                </div>
                <div className="footer-form-actions">
                  <button type="submit" className="footer-submit" disabled={status === 'sending'}>
                    {status === 'sending' ? 'Sending…' : 'Send Message'}
                  </button>
                  {status === 'error' && (
                    <p className="footer-form-error">Something went wrong. Please try again or email us directly.</p>
                  )}
                </div>
              </form>
            )}
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-brand-row">
            <img src="/images/logo.png" alt="Aranyakam" className="footer-logo-img" />
            <span className="footer-logo-name">Aranyakam</span>
          </div>
          <p className="footer-copy">© {new Date().getFullYear()} Aranyakam. All rights reserved.</p>
          <div className="footer-nav">
            <a href="#about">About</a>
            <a href="#sectors">Sectors</a>
            <a href="#portfolio">Portfolio</a>
            <a href="#team">Team</a>
            <a href="#stories">Stories</a>
          </div>
        </div>

      </div>
    </footer>
  );
}
